export enum QueryStringParamName {
  WebId = 'WebId',
  Bundle = 'bundle',
  IsMover = 'isMover',
  IsChangePlan = 'isChangePlan',
  IsExistingMover = 'isExistingMover',
  IsCarbonNeutral = 'isCarbonNeutral',
  AGLFunnelSQ = 'AGLFunnelSQ',
  BridgePageOrigin = 'bridgePageOrigin',
  CouponCode = 'couponCode',
  CurrentPlanSku = 'currentPlanSku'
}
export enum SignupParamName {
  WebId = 'WebId'
}
export enum ExternalEventName {
  ProductDisclaimerAnchorClick = 'window:product-card-disclaimer-click'
}
export enum EventName {
  BannerToggleChanged = 'BannerToggleChanged',
  RatesToggleChanged = 'RatesToggleChanged',
  VisibleFuelTypeChanged = 'VisibleFuelTypeChanged',
  TariffSelectionChanged = 'TariffSelectionChanged',
  CrossSellButtonClicked = 'CrossSellButtonClicked'
}

export enum Cidi {
  SessionRestartOrCheckoutChangeAddress = 'A10440',
  BasicPlanInforLink = 'A10439'
}

export enum ContentMode {
  Preview = 'preview',
  Publish = 'publish'
}

export enum ApplicationError {
  LoadConfig = 'loadConfig'
}
